import axios from "axios";
import { Login } from "../pages/Login";
import { Navigate } from "react-router-dom";

const api = axios.create({
  baseURL: 'https://api.cadclin.com.br/prod',
});

export const useApi = () => ({
  signin: async (email: string, password: string) => {
    try {
      const response = await api.post("/login", { email, password });
      if (response) {
        return response.data;
      }
    } catch (error) {
      console.log("Erro ao logar", error);
      return error;
    }
  },

  validateUser: async (data: string) => {
    //console.log("O que tem aqui no data", data);

    const objData = JSON.parse(data);

    return {
      user: {
        id: objData.id,
        organization: objData.organization,
        role: objData.role,
      },
    };
  },

  logout: async () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
  },
});
